import React, { useState, useEffect, useContext } from "react";
export const AuthContext = React.createContext();
export const useAuth = () => useContext(AuthContext);
export const AuthProvider = ({
    children
}) => { 
    const [authObj, setAuthObj] = useState({
        isLoading: true,
        isAuthenticated: false,
        isRegistered: false,
        isEnabled: false,
        getUserComplete: false,
        authError: '',
        userObj: {},
        claimsArr: []
    });
    useEffect(() => {
        getUser();
    }, []);


    const getUser = async () => {  
        const response = await fetch('/auth/GetUser', { credentials: 'include' });
        try {
            if (response.status === 200) {
                const json = await response.json();
                if (json.isAuthenticated && json.authError === "854A7F26-BCC5-42A7-A8DF-98A1BC97B9B8") {
                    aadLogin();
                }
                else {
                    var userContact = (json.isAuthenticated) ? json.contact : {};
                    var userClaims = (json.isAuthenticated) ? json.claims : [];

                    //US10683113 Store user information in session storage for Qualtrics
                    if (json.isAuthenticated && json.isEnabled && userContact) {
                        const qualtricsUserData = {
                            uid: userContact.email || '',
                            name: `${userContact.firstName || ''} ${userContact.lastName || ''}`.trim(),
                            email: userContact.email || '',
                        };
                        sessionStorage.setItem('qualtricsUserData', JSON.stringify(qualtricsUserData));
                        window.qualtricsUserData = qualtricsUserData;
                        console.log(`Loading Qualtrics User Info: ${JSON.stringify(qualtricsUserData)}`);
                    }

                    setAuthObj({
                        isLoading: false,
                        isAuthenticated: json.isAuthenticated,
                        isRegistered: json.isRegistered,
                        isEnabled: json.isEnabled,
                        getUserComplete: true,
                        authError: json.authError,
                        userObj: userContact,
                        claimsArr: userClaims
                    });
                }
            }
            else {
               // console.log(`Error in GetUser call. Server Status ${response.status}`);
            }
            
        } catch (e) {
            //console.log(`Error getting user. Redirect to 401 Ex: ${e.message}  Response:${response}`);
            setAuthObj({
                isLoading: false,
                isAuthenticated: false,
                getUserComplete: true,
                authError: "Error in GetUser",
                userObj: {},
                claimsArr: []
            });           
        }       
    }

    const login = () => {
        window.location.href = '/auth/login';
    }

    const logout = () => {
        sessionStorage.removeItem("curSupName");
        window.location.href = '/auth/logout';
    }
    const aadLogin = () => {
        window.location.href = '/auth/aadLogin';
    }
    //const aadLogout = () => {
    //    window.location.href = '/auth/aadLogout';
    //}

    return (
        <AuthContext.Provider
            value={{
                authObj,
                login,
                logout,
                getUser
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};